export default __webpack_public_path__ + "static/media/previous-collection--collection-2.bda0296e.png";